import type { IconName } from "./SolIcon";

export const slugify = (s: string) =>
  s.toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export type TabKey = "intelligence" | "enterprise" | "industry";

export const tabs: {
  key: TabKey;
  title: string;
  tagline: string;
  intro: string;
  icon: IconName;
}[] = [
  {
    key: "intelligence",
    title: "Intelligence Solutions",
    tagline: "Understand. Predict. Recommend. Act.",
    intro: "AI-enabled insights and decision intelligence across business functions.",
    icon: "bulb",
  },
  {
    key: "enterprise",
    title: "Enterprise Solutions & Accelerators",
    tagline: "Solve key processes end-to-end.",
    intro: "Pre-configured, industry-tested solutions on SAP and cloud, enhanced with AI and analytics.",
    icon: "gear",
  },
  {
    key: "industry",
    title: "Industry Solutions",
    tagline: "Proven templates. Faster outcomes.",
    intro: "Ready-to-deploy industry solutions combining process, data and AI.",
    icon: "building",
  },
];

export const intelligence: { no: string; title: string; text: string; icon: IconName }[] = [
  { no: "01", title: "Inventory Intelligence", text: "Right inventory. Lower cost. Higher service.", icon: "cube" },
  { no: "02", title: "Cash & Working Capital Intelligence", text: "Free up cash. Improve liquidity. Enable growth.", icon: "coins" },
  { no: "03", title: "Margin & Profitability Intelligence", text: "See what drives profit. Fix what doesn't. Grow what works.", icon: "trend-bars" },
  { no: "04", title: "Spend & Vendor Intelligence", text: "Smarter spend. Stronger suppliers. Greater value.", icon: "cart" },
  { no: "05", title: "Asset & Spare Intelligence", text: "Maximise asset uptime and optimise spares.", icon: "gear" },
  { no: "06", title: "Customer & Revenue Intelligence", text: "Understand customers. Grow revenue. Improve retention.", icon: "people" },
  { no: "07", title: "People Intelligence", text: "Plan, develop and optimise your workforce.", icon: "person" },
  { no: "08", title: "CXO Intelligence", text: "A single view for CIO, CFO, CPO, CEO and MD.", icon: "target" },
];

export const enterprise: { title: string; text: string; icon: IconName }[] = [
  { title: "Invoice Management (VIM)", text: "Intelligent AP processing with AI, matching, exceptions and compliance.", icon: "doc" },
  { title: "Procurement Excellence", text: "Source to Pay, supplier collaboration and category management.", icon: "cart" },
  { title: "Tax Technology", text: "Direct, indirect and global tax compliance automation.", icon: "tax" },
  { title: "Disclosure & Consolidation", text: "Financial close, consolidation, disclosures and regulatory reporting.", icon: "columns" },
  { title: "Vendor / Customer Portals", text: "Self-service portals for suppliers, dealers and customers.", icon: "portal" },
  { title: "Master Data & Data Quality", text: "Govern, cleanse and enrich master data across domains.", icon: "database" },
  { title: "Enterprise Workflow & Approvals", text: "Automate approvals, policy compliance and exception handling.", icon: "workflow" },
  { title: "Document & Contract Management", text: "Contracts, NDAs, legal documents and lifecycle management.", icon: "doc" },
  { title: "Industry Accelerators", text: "Pre-built templates and rapid deployment accelerators.", icon: "accelerator" },
];

export const industry: { title: string; text: string; image: string; href: string }[] = [
  { title: "Retail & CPG", text: "Demand planning, assortment, promotions, trade spend and store operations.", image: "/assets/images/fmcg_retail.jpg", href: "/industries/fmcg-retail" },
  { title: "Manufacturing", text: "Production, plant operations, supply chain and quality.", image: "/assets/images/manufacturing.jpg", href: "/industries/manufacturing" },
  { title: "Pharma & Healthcare", text: "Batch tracking, compliance and supply chain visibility.", image: "/assets/images/pharma.jpg", href: "/industries/pharma-lifescience" },
  { title: "Auto & Industrial", text: "Dealer network, aftermarket, parts and service.", image: "/assets/images/auto-industrial.jpg", href: "" },
  { title: "Utilities & Energy", text: "Field operations, asset management and regulatory reporting.", image: "/assets/images/energy_utilities.jpg", href: "/industries/energy-utilities" },
  { title: "Professional Services", text: "Project delivery, resource management and profitability.", image: "/assets/images/professional-services2.jpg", href: "/industries/professional-services" },
];

export const steps: { title: string; text: string; icon: IconName }[] = [
  { title: "Discover", text: "Understand your business questions and opportunities.", icon: "search" },
  { title: "Assess", text: "Analyse current state, data and quick wins.", icon: "doc" },
  { title: "Design", text: "Tailor solution, use cases and implementation plan.", icon: "gear" },
  { title: "Deploy", text: "Implement with industry templates and accelerators.", icon: "cloud" },
  { title: "Scale", text: "Measure outcomes and continuously improve.", icon: "bars" },
];

export const typicalOutcomes: { value: string; label: string; icon: IconName }[] = [
  { value: "10–30%", label: "Higher productivity", icon: "trend-up" },
  { value: "15–40%", label: "Lower operating cost", icon: "coins" },
  { value: "30–50%", label: "Faster cycle times", icon: "clock" },
  { value: "Improved", label: "Compliance & control", icon: "shield" },
];
